module.exports = __webpack_public_path__ + "static/media/amazon_clone_pic_break.fb4daa34.jpg";